import styled from 'styled-components';

export const StyledBookmarksSidebar = styled.div`
  background-color: #fbfbfb;
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);
  left: ${props => (props.isOpened ? '0' : '-100vw')};
  overflow-y: auto;
  padding: 1.25em 1.5em;
  position: fixed;
  top: 40px;
  transition: 0.5s ease;
  width: 100vw;
  z-index: 2500;
`;

export const StyledBookmarksWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledBookmarksHeader = styled.div`
  align-items: center;
  background: rgba(106, 160, 241, 0.2);
  border-radius: 3px;
  display: flex;
  justify-content: center;
  margin-bottom: 1.5rem;
  min-height: fit-content;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: fit-content;

  > span {
    font-weight: 500;
    color: #4f4f4f;
  }

  > span:last-child {
    width: 32px;
  }
`;

export const StyledLine = styled.hr`
  width: 100%;
  border: 0.5px solid #c8c8c8;
  margin-bottom: 1.25em;
`;
